<div class="airline-contact-popup">
  <div class="airline-contact-popup-header">
    <h1 i18n="@@global.airline-contact">Airline Contact</h1>
    <svg
      (click)="closeModal()"
      style="cursor: pointer"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.174 15.4505C17.4029 15.6794 17.5316 15.99 17.5316 16.3138C17.5316 16.6375 17.4029 16.9481 17.174 17.177C16.945 17.406 16.6345 17.5346 16.3107 17.5346C15.9869 17.5346 15.6764 17.406 15.4474 17.177L8.99922 10.7268L2.54899 17.175C2.32003 17.404 2.0095 17.5326 1.68571 17.5326C1.36191 17.5326 1.05138 17.404 0.822427 17.175C0.59347 16.946 0.464844 16.6355 0.464844 16.3117C0.464844 15.9879 0.59347 15.6774 0.822427 15.4484L7.27266 9.00024L0.824458 2.55C0.595501 2.32105 0.466875 2.01052 0.466875 1.68672C0.466875 1.36293 0.595501 1.0524 0.824458 0.823442C1.05341 0.594486 1.36395 0.465859 1.68774 0.465859C2.01153 0.465859 2.32206 0.594486 2.55102 0.823442L8.99922 7.27368L15.4495 0.822426C15.6784 0.59347 15.9889 0.464844 16.3127 0.464844C16.6365 0.464844 16.9471 0.59347 17.176 0.822426C17.405 1.05138 17.5336 1.36191 17.5336 1.68571C17.5336 2.0095 17.405 2.32003 17.176 2.54899L10.7258 9.00024L17.174 15.4505Z"
        fill="#1F1F1F"
      />
    </svg>
  </div>

  @for (
    airlineContact of airlineContactsDisplay;
    track airlineContact;
    let isLast = $last
  ) {
    <div class="airline-contact-container">
      <div>
        <h2 class="contact-header">{{ airlineContact.contactType }}</h2>
        <div class="contact-tag-container">
          @for (tag of airlineContact.contactTypeTags; track tag) {
            <div class="contact-tag">{{ tag }}</div>
          }
        </div>
      </div>
      <div class="contact-body">
        <div class="contact-info">
          <span i18n="@@global.phone-number">Phone</span>
          <span
            (click)="copyToClipboard(getPhoneNumber(airlineContact.contact))"
            [matTooltip]="'Copy'"
            matTooltipPosition="below"
            >{{ getPhoneNumber(airlineContact.contact) }}</span
          >
        </div>
        <div class="contact-info">
          <span i18n="@@global.email">Email</span>
          <span
            (click)="copyToClipboard(getEmail(airlineContact.contact))"
            style="text-decoration: underline"
            [matTooltip]="'Copy'"
            matTooltipPosition="below"
            >{{ getEmail(airlineContact.contact) }}</span
          >
        </div>
      </div>
      @if (!isLast) {
        <svg
          class="divider"
          width="386"
          height="1"
          viewBox="0 0 386 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line y1="0.5" x2="386" y2="0.5" stroke="#D6D6D6" />
        </svg>
      }
    </div>
  }

  <div class="airline-contact-popup-footer" (click)="goToAirlineContactPage()">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7C13.3674 7 13.2402 6.94732 13.1464 6.85355C13.0527 6.75979 13 6.63261 13 6.5V3.7075L8.85437 7.85375C8.76055 7.94757 8.63331 8.00028 8.50062 8.00028C8.36794 8.00028 8.2407 7.94757 8.14688 7.85375C8.05305 7.75993 8.00035 7.63268 8.00035 7.5C8.00035 7.36732 8.05305 7.24007 8.14688 7.14625L12.2925 3H9.5C9.36739 3 9.24021 2.94732 9.14645 2.85355C9.05268 2.75979 9 2.63261 9 2.5C9 2.36739 9.05268 2.24021 9.14645 2.14645C9.24021 2.05268 9.36739 2 9.5 2H13.5C13.6326 2 13.7598 2.05268 13.8536 2.14645C13.9473 2.24021 14 2.36739 14 2.5V6.5ZM11.5 8C11.3674 8 11.2402 8.05268 11.1464 8.14645C11.0527 8.24021 11 8.36739 11 8.5V13H3V5H7.5C7.63261 5 7.75979 4.94732 7.85355 4.85355C7.94732 4.75979 8 4.63261 8 4.5C8 4.36739 7.94732 4.24021 7.85355 4.14645C7.75979 4.05268 7.63261 4 7.5 4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13V8.5C12 8.36739 11.9473 8.24021 11.8536 8.14645C11.7598 8.05268 11.6326 8 11.5 8Z"
        fill="#7E47C5"
      />
    </svg>
    <a i18n="@@compare-rate.airline-contact-page">Airline contact page</a>
  </div>
</div>
